export default __webpack_public_path__ + "static/media/code.e6d8094c.png";